import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { Button, Modal } from 'edozvola-frontend-lib/dist/ui';
import React, { useState } from 'react';
import { useParams } from 'react-router';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import {
  copyConstructionQuery,
  deleteConstructionQuery,
  fetchConstructionsQuery,
} from '../service/construction-building-procedure.queries';
import { ConstructionView } from 'app/edozvola/cases/construction-building-procedure/constructions/model/construction.model';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

const ConstructionTable = ({ setIdConstruction, setReadOnly, variant }) => {
  const { id: uuid } = useParams<{ id: string }>();
  const [idConstructionToDelete, setIdConstructionToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.CONSTRUCTIONS_TABLE);

  const { mutate: deleteConstructionMutation, isPending: isDeletingConstruction } = deleteConstructionQuery(variant);
  const { mutate: copyConstructionMutation, isPending: isCopyingConstruction } = copyConstructionQuery(variant);

  const openConstructionForm = (idConstruction: number, readOnly: boolean) => {
    setIdConstruction(idConstruction);
    setReadOnly(readOnly);
  };

  const openDeleteDialog = idToDelete => {
    setIdConstructionToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removeConstruction = () => {
    setDeleteModalShown(false);
    deleteConstructionMutation(idConstructionToDelete);
  };

  const renderTableRow = (value: ConstructionView, constructionIndex: number, totalItems: number) => {
    return (
      <tr key={constructionIndex} className={invalidRowIds.includes(value.idConstruction) ? 'invalid-table-row' : ''}>
        <td> {value.cbpBuildingPurpose?.split('\n').map((line, i) => <div key={i}>{line}</div>)}</td>
        <td>{value.buildingPurposeAdditionalDescription}</td>
        <td>{value.requirementGroup}</td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj'}>
                <FontAwesomeIcon icon={'eye'} className={'icon-table'} onClick={() => openConstructionForm(value.idConstruction, true)} />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canEdit && (
              <TooltipWrapper message={'Uredi'}>
                <FontAwesomeIcon
                  icon={'pen-to-square'}
                  className={'icon-table'}
                  onClick={() => openConstructionForm(value.idConstruction, false)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canCopy && (
              <TooltipWrapper message={'Kopiraj'}>
                <FontAwesomeIcon icon={'copy'} className={'icon-table'} onClick={() => copyConstructionMutation(value.idConstruction)} />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value.idConstruction)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema građevina'}
        initialPaginationColumn={'cbpBuildingPurpose'}
        fetchDataQuery={fetchConstructionsQuery}
        fetchDataProps={[uuid]}
      >
        <ViewTableHeaderColumn renderSort={ false } columnLabels={ ['Vrsta zahvata / Namjena'] } width={ '150px' }/>
        <ViewTableHeaderColumn renderSort={ false } columnLabels={ ['Dodatni opis namjene'] } width={ '200px' }/>
        <ViewTableHeaderColumn renderSort={ false } columnLabels={ ['Skupina prema zahtjevnosti'] } width={ '200px' }/>
        <ViewTableHeaderColumn renderSort={ false } columnLabels={ ['Akcije'] } width={ '100px' }/>
      </ViewTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje građevine</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} />
          <Button size={'lg'} label="Obriši" color={'danger'} onClick={removeConstruction} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ConstructionTable;
